export default __webpack_public_path__ + "static/media/van.fbb3da3d.svg";